import { render, staticRenderFns } from "./ChangeType.vue?vue&type=template&id=76fb0210&scoped=true"
import script from "./ChangeType.vue?vue&type=script&lang=js"
export * from "./ChangeType.vue?vue&type=script&lang=js"
import style0 from "./ChangeType.vue?vue&type=style&index=0&id=76fb0210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb0210",
  null
  
)

export default component.exports